import { useMemo } from 'react';
import { ScrollView, View } from 'react-native';
import { Text } from '@/components/Text';
import { useWordsetContext } from '@/contexts/WordSetContext/useWordsetContext';
import { styles } from './styles';
import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';
import Checkbox from '@/components/ui/therapist/Checkbox';
import { IS_WEB } from '@/utils/platform';

export function Phonemauswahl({ data, keyName }) {
  const {
    phonemes,
    changePhenomenonState,
    changePhenomenonRowState,
    changeAllPhenomenonState,
  } = useWordsetContext();
  const { title, selectAllText, Vokale, Plosive, Frikative, Nasale, Weitere } =
    data;
  const activePhonemesSelected = phonemes[keyName + 'Selected'];
  const wrappedData = [
    { name: 'Vokale', values: Vokale },
    { name: 'Plosive', values: Plosive },
    { name: 'Frikative', values: Frikative },
    { name: 'Nasale', values: Nasale },
    { name: 'Weitere', values: Weitere },
  ];

  const ALL_VALUES = [
    ...wrappedData[0].values,
    ...wrappedData[1].values,
    ...wrappedData[2].values,
    ...wrappedData[3].values,
    ...wrappedData[4].values,
  ];

  const handleAlleCheckboxPress = (name, values = ALL_VALUES, isRemove) => {
    changeAllPhenomenonState(name, values, isRemove);
  };

  const phonemeCheckboxContainerPress = (name, values, isRemove) => {
    changePhenomenonRowState(name, values, isRemove);
  };

  const phonemeCheckboxPress = (name, value, isRemove) => {
    changePhenomenonState(name, value, isRemove);
  };

  const isAlleCheckboxChecked = useMemo(() => {
    return phonemes[keyName + 'Selected'].length === ALL_VALUES.length;
  }, [phonemes[keyName + 'Selected'].length]);
  const height = useResponsiveHeight(40);

  return (
    <View
      style={[
        styles.phonemauswahlContainer,
        { height, flex: IS_WEB ? null : 1 },
      ]}
    >
      <ScrollView>
        <Text style={styles.phonemauswahlTitle}>{title}</Text>
        <Checkbox
          isSelected={isAlleCheckboxChecked}
          label={selectAllText}
          labelStyle={{ fontSize: 20, fontWeight: 'bold' }}
          onPress={() =>
            handleAlleCheckboxPress(keyName, ALL_VALUES, isAlleCheckboxChecked)
          }
        />
        <View style={styles.horizantalSeperator} />
        {wrappedData.map((data, outerIndex) => {
          const { name, values } = data;
          const isSectorContainerCheckboxChecked = (() => {
            let isChecked = false;
            for (let i = 0; i < values.length; i++) {
              const eachValue = values[i];
              if (activePhonemesSelected.includes(eachValue)) {
                isChecked = true;
              } else {
                isChecked = false;
                break;
              }
            }
            return isChecked;
          })();

          return (
            <View style={styles.sectorContainer} key={name}>
              <Checkbox
                isSelected={isSectorContainerCheckboxChecked}
                label={name}
                labelStyle={{ fontSize: 20, fontWeight: 'bold' }}
                onPress={() =>
                  phonemeCheckboxContainerPress(
                    keyName,
                    values,
                    isSectorContainerCheckboxChecked,
                  )
                }
              />
              <View style={styles.sectorContainerBody}>
                {values.map((value) => {
                  const isChecked = activePhonemesSelected.includes(value);
                  return (
                    <View key={value} style={styles.sectorContainerBodyItem}>
                      <Checkbox
                        isSelected={isChecked}
                        label={value}
                        labelStyle={{ fontSize: 20 }}
                        onPress={() =>
                          phonemeCheckboxPress(keyName, value, isChecked)
                        }
                      />
                    </View>
                  );
                })}
              </View>
              {outerIndex !== wrappedData.length - 1 ? (
                <View style={styles.horizantalSeperator} />
              ) : null}
            </View>
          );
        })}
      </ScrollView>
    </View>
  );
}
